<template>
    <div v-show="hasSlot" class="flex items-center">
        <div v-if="hasContent" data-divider class="h-full mx-3 border-0 border-l border-solid border-gray-700" />

        <div ref="container" class="flex items-center grid gap-3" style="grid-auto-flow: column">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            hasContent: false,
            observer: new MutationObserver(() => this.checkContent()),
        }
    },

    computed: {
        hasSlot() {
            return !!this.$slots.default
        },
    },

    mounted() {
        this.observer.observe(this.$refs.container, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true,
        })

        this.checkContent()
    },

    updated() {
        this.checkContent()
    },

    methods: {
        checkContent() {
            this.$nextTick(function() {
                this.hasContent = this.$refs.container && $(this.$refs.container).children().length > 0
            })
        }
    }
}
</script>

<style scoped lang="scss">
    :first-child > [data-divider] {
        display: none !important;
    }
</style>